import key from 'ally.js/esm/when/key';
import tabFocus from 'ally.js/esm/maintain/tab-focus';
import disabled from 'ally.js/esm/maintain/disabled';
import {wrapInner} from '../base/utils';

class A11y {
    constructor() {}

    static focusTrap($context, $trigger, closeCallback) {
        let escHandler = key({
            escape: (e, disengage) => {
                closeCallback();
                $trigger.focus();

                disengage();
            },
        });

        let tabHandler = tabFocus({
            context: $context
        });

        let disableHandler = disabled({
            filter: [$context]
        });

        return {escHandler, tabHandler, disableHandler};
    }

    static removeFocusTrap(handlers) {
        if (!handlers) {
            return;
        }

        if (handlers.tabHandler) handlers.tabHandler.disengage();
        handlers.tabHandler = null;
        if (handlers.disableHandler) handlers.disableHandler.disengage();
        handlers.disableHandler = null;
        if (handlers.escHandler) handlers.escHandler.disengage();
        handlers.escHandler = null;

        return handlers;
    }

    static abbr($context = document.body) {
        for (let $el of $context.querySelectorAll('abbr')) {
            wrapInner($el, 'span', 'aria-hidden', 'true');
            $el.insertAdjacentHTML('beforeend', `<span class="visuallyhidden">${$el.title}</span>`);
        }
    }
}

export default A11y;
